import { usePage } from '@inertiajs/vue3';
import Locale from '../Models/Locale';

export function useCurrentLocale() {
    return new Locale(usePage().props.locale);
}
